import React from 'react';
import { ClickableBox, SpacingBox, FlexBox } from '../Components/Boxes';
import { Bold, Paragraph } from '../Components/Typography';
import { getPriceType } from '../selectors';
import { getTranslateByScope } from '../i18n';
import { priceTypes } from '../constants';
import AppContext from '../AppContext';

const translate = getTranslateByScope('app.settingsMenu');
const options = [
  { value: priceTypes.mrsp, label: translate('msrp') },
  { value: priceTypes.unit, label: translate('unit') },
];

const PriceType = ({ value, label }) => (
  <AppContext.Consumer>
    {(context) => (
      <SpacingBox marginRight="sm">
        <ClickableBox
          onClick={() => {
            window.location.reload();
            context.actions.changePriceType(value);
          }}>
          {/* 1804Ginto has no 500 weight, so the default Bold looks regular */}
          {getPriceType(context) === value ? (
            <Bold style={{ fontWeight: 700 }}>{label}</Bold>
          ) : (
            <Paragraph>{label}</Paragraph>
          )}
        </ClickableBox>
      </SpacingBox>
    )}
  </AppContext.Consumer>
);

export const PriceTypePicker = () => (
  <FlexBox>
    {options.map((p) => (
      <PriceType key={p.value} value={p.value} label={p.label} />
    ))}
  </FlexBox>
);

export default PriceTypePicker;
